import FieldMultiselect_Picker from "../../../../generic/multiselect/render/picker"
import {FieldMultiselectEditableProps} from "../../../../generic/multiselect/render/inline-editable"
import Goal from "../../../../../model2/goal/goal"

export default class FieldGoalAssignees_Picker extends FieldMultiselect_Picker {
    constructor(props:FieldMultiselectEditableProps) {
        super(props)

        const goal = this.props.model as Goal

        this.state = {
            initialPropsValue   : goal.assigneeUserIds,
            currentOptions      : goal.assigneeUserIds,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const goal = props.model as Goal
        const value = goal.assigneeUserIds // new value

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOptions      : value
            }
        }

        return null // no changes
    }
}

